<template>
  <a-modal
      title="编辑资料"
      :visible="editVisible"
      :maskClosable="false"
      width="80vw" centered
      destroyOnClose
      :footer="null"
      @cancel="onCancel">
    <expert-form ref="EditForm" :form="form" :isEdit="isEdit" :spinLoading="spinLoading" @success="editSuccess"/>
  </a-modal>
</template>

<script>

import expertForm from '@/epp/expertmain/expertInfo/common/ExpertForm.vue'
import {  GetExpertInfo } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment'

export default {
  name: 'ExpertEdit',
  components: {
    expertForm
  },
  props: {
  },
  data () {
    return {
      form: {},
      spinLoading: false,
      isEdit: true,
      editVisible: false
    }
  },
  computed: {

  },
  created () {
  },
  methods: {
    async loadData (id) {
      try {
        this.editVisible = true
        this.spinLoading = true
        const res = await GetExpertInfo(id)
        if (!res.result) {
          this.isEdit = false
        }
        this.form = res.result
        this.form.otherSourceLibrary = res.result.otherSourceLibrary && res.result.otherSourceLibrary.split(',')
        this.form.avoidUnit = this.form.avoidUnit && this.form.avoidUnit.replace(/,/g, '\n')
        this.form.retireDate = this.form.retireDate && moment(this.form.retireDate)
        if (this.form.otherSpecificProfessionalTitle) {
          this.form.specificProfessionalTitle = this.form.specificProfessionalTitle?this.form.specificProfessionalTitle + '；' + this.form.otherSpecificProfessionalTitle:this.form.otherSpecificProfessionalTitle
        }
      } catch (e) {
        this.isEdit = false
      } finally {
        this.spinLoading = false
      }
    },
    editSuccess () {
      this.editVisible = false
      this.$emit('success')
      this.$emit('openViewExpert')
    },
    onCancel(){
      this.editVisible = false
      this.$emit('openViewExpert')
    }
  }
}
</script>

<style></style>
